import { BigNumber } from 'ethers'
import { MarketIndexes } from '../../api/v1/market'
import { Pow18 } from '../../config'
import { SymbolName, Wei } from '../../types'
import { bn, e2w } from '../number'
import { CurrencyBalance } from '../../store/account/types'

/**
 * Calculates the total spot available value based on the given balances and market indexes.
 *
 * @param balances - The array of currency balances.
 * @param indexes - The market indexes.
 * @returns The total spot available value as a string.
 */
export function calcTotalSpotAvailableValue(
  balances: CurrencyBalance[],
  indexes: MarketIndexes,
): Wei {
  if (!balances || !indexes) return '0'
  return balances
    .reduce((prev, current): BigNumber => {
      const price = indexes[current.currency] ? indexes[current.currency][1] : 0
      const value = bn(current.available).mul(e2w(price)).div(Pow18)
      return prev.add(value)
    }, bn('0'))
    .toString()
}

export function calcSpotValueByExternalPrices(
  balances: CurrencyBalance[],
  indexes: Record<SymbolName, number>,
): Wei {
  if (!balances || !indexes) return '0'
  return balances
    .reduce((prev, current): BigNumber => {
      const price = indexes[current.currency.toUpperCase()]
        ? indexes[current.currency.toUpperCase()]
        : 0
      const value = bn(current.available).mul(e2w(price)).div(Pow18)
      return prev.add(value)
    }, bn('0'))
    .toString()
}
